import {map} from 'rxjs/operators';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ITableHeader} from '../../../../shared/table/TableComponent';
import {KeepingCurrentReportFormComponent} from '../form/KeepingCurrentReportFormComponent';
import {MissedPaymentReport} from '../../../../../services/api.client';
import {BehaviorSubject, Observable} from 'rxjs';
import {formatCurrency} from '../../../../../utilities/Util';
import {SHORT_DATE_FORMAT} from '../../../../../constants';
import {formatDate} from '../../../../../utilities/date-util';

@Component({
    selector: 'missed-payments-reports',
    templateUrl: './MissedPaymentsReportComponent.html',
    standalone: false
})
export class MissedPaymentsReportComponent implements OnInit {

    tableHeaders: ITableHeader[] = [
        {text: 'Agency'},
        {text: 'Customer'},
        {text: 'Account Number'},
        {text: 'Delinquent Date'},
        {text: 'Billing Date'},
        {text: 'Amount Due'},
        {text: 'Amount Paid'},
        {text: 'Import Date'},
        {text: 'Enrollment Date'}
    ];

    @ViewChild('form')
    form: KeepingCurrentReportFormComponent;

    private readonly _report$ = new BehaviorSubject<MissedPaymentReport[]>(null);
    report$: Observable<MissedPaymentReport[]> = this._report$.asObservable();
    rows: any;

    ngOnInit(): void {
        this.rows = this.report$
            .exists().pipe(
                map((report) => report.map(r => [
                    r.agency,
                    r.customer,
                    r.accountNumber,
                    formatDate(r.delinquentDate, SHORT_DATE_FORMAT),
                    formatDate(r.billingDate, SHORT_DATE_FORMAT),
                    formatCurrency(r.amountDue),
                    formatCurrency(r.amountPaid),
                    formatDate(r.importDate, SHORT_DATE_FORMAT),
                    formatDate(r.enrollmentDate, SHORT_DATE_FORMAT)
                ])));

    }

    submitReport(): void {
        this.form.submitMissedPaymentsReport().subscribe({next: (report) => this._report$.next(report), error: () => {}});
    }
}
